import React, { useContext, useEffect, useState } from "react";
import { ModalHeader } from "reactstrap";
import { Btn, H3 } from "../../../AbstractElements";
import {
  FaAngleDoubleLeft,
  FaAngleLeft,
  FaAngleRight,
  FaAngleDoubleRight,
} from "react-icons/fa";
import NoteContext from "../Context/Index";

export default function NoteModalHeader({ title, firstId, lastId }) {
  const {
    item,
    getItem,
    isAdding,
    totalRows,
    index,
    setIndex,
    nextId,
    previousId,
    getNextNote,
    getPreviousNote,
  } = useContext(NoteContext);
  const [itemId, setItemId] = useState();

  const handleNext = () => {
    if (index < totalRows - 1) {
      setItemId(nextId);
      setIndex(index + 1);
    }
  };

  const handlePrevious = () => {
    if (index > 0) {
      setItemId(previousId);
      setIndex(index - 1);
    }
  };

  const handleFirst = () => {
    setIndex(0);
    setItemId(firstId);
  };

  const handleLast = () => {
    setIndex(totalRows - 1);
    setItemId(lastId);
  };

  useEffect(() => {
    if (itemId != undefined) {
      getItem(itemId);
    }
  }, [itemId]);

  useEffect(() => {
    if (item?.id) {
      setItemId(item?.id);

      if (item?.model_id != undefined) {
        getNextNote(item?.model_id);
        getPreviousNote(item?.model_id);
      }
    }
  }, [item]);

  return (
    <ModalHeader className="bg-primary">
      <div className="d-flex justify-content-between align-items-center">
        <H3
          attrH3={{
            className: "modal-title text-white m-0",
            id: "modalTitle",
          }}
        >
          {title}
        </H3>
        {!isAdding && (
          <div className="d-flex align-items-center gap-2 ms-auto">
            <Btn
              attrBtn={{
                className: "btn-no-bg-color",
                onClick: handleFirst,
                style: {
                  padding: "0.6rem 0.75rem",
                  backgroundColor: "transparent",
                  border: "none",
                  color: "#FFF080",
                },
              }}
            >
              <FaAngleDoubleLeft />
            </Btn>
            <Btn
              attrBtn={{
                className: "btn-no-bg-color",
                onClick: handlePrevious,
                style: {
                  padding: "0.6rem 0.75rem",
                  backgroundColor: "transparent",
                  border: "none",
                  color: "#FFF080",
                },
              }}
            >
              <FaAngleLeft />
            </Btn>
            <span className="fw-bold">
              {index + 1} de {totalRows}
            </span>
            <Btn
              attrBtn={{
                className: "btn-no-bg-color",
                onClick: handleNext,
                style: {
                  padding: "0.6rem 0.75rem",
                  backgroundColor: "transparent",
                  border: "none",
                  color: "#FFF080",
                },
              }}
            >
              <FaAngleRight />
            </Btn>
            <Btn
              attrBtn={{
                className: "btn-no-bg-color",
                onClick: handleLast,
                style: {
                  padding: "0.6rem 0.75rem",
                  backgroundColor: "transparent",
                  border: "none",
                  color: "#FFF080",
                },
              }}
            >
              <FaAngleDoubleRight />
            </Btn>
          </div>
        )}
      </div>
    </ModalHeader>
  );
}
